import { FC } from 'react'

const Dashboard: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  fill: fillProp,
  height,
  width,
  ...rest
}) => {
  const fill = fillProp || '#1D1D1F'
  return (
    <svg
      className={className}
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <circle cx='6.35865' cy='6.35889' r='3.52564' fill={fill} />
      <circle
        cx='6.35865'
        cy='17.6411'
        r='2.82564'
        className='stroke'
        stroke={fill}
        strokeWidth='1.4'
      />
      <circle
        cx='17.6409'
        cy='6.35889'
        r='2.82564'
        className='stroke'
        stroke={fill}
        strokeWidth='1.4'
      />
      <path
        d='M17.5 14.5002V21.0002'
        stroke={fill}
        className='stroke'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.75 17.7502L14.25 17.7502'
        stroke={fill}
        className='stroke'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Dashboard
